import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Payment_fail() {
    const port = process.env.REACT_APP_SECRET;
    const navigate = useNavigate();
    const id = localStorage.getItem('offer_id_user')

    return (
        <>
            <div className="d-flex flex-column gap-4 w-100 align-items-center text-center justify-content-center payment-fail mt-5">
                <h3>Payment Failed! </h3>
                <button onClick={() => navigate(`/dashboard//offers-user/${id}`)}>Try Again</button>
            </div>
        </>
    );
}

export default Payment_fail;
